<template>
  <h2>新着ファンド</h2>
  <FundTile :fund-id="fundItem.fund_id" :fund-name="fundItem.fund_name" :explanation-short="fundItem.explanation_short"
    :thumbnail-uri="thumbnail_uri" :partner-name="fundItem.partner_name" :supporter="fundItem.supporter"
    :is-watch="fundItem.isWatched" :price="fundItem.price" :amount="fundItem.amount" :total-amount="fundItem.total_price"/>
</template>

<script>
import axios from 'axios'
import FundTile from './FundTile.vue'

export default {
  name: 'FundNewer',
  components: {
    FundTile
  },
  props: {},
  data() {
    return {
      fundItem: [],
      thumbnail_uri: '',
    }
  },
  mounted() {
    this.fetchFundList();
  },
  methods: {
    async fetchFundList() {
      try {
        const res = await axios.get('/api/fund/newer')
        this.fundItem = res.data;
        console.log(this.fundItem);
        this.thumbnail_uri = `/data/fund/${res.data.fund_id}/toplist.jpg`;
      } catch (error) {
        console.log(error)
        return
      }
    }
  }
}
</script>